import React from 'react';

import { CashBalanceButton } from '@/components/BalanceButton';
import { Screen } from '@/components/ScreenComponent';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';

import { GameResultsSectionList } from '../components/GameResultsSectionList';

export const ArcadeResultsScreen = () => {
    return (
        <Screen>
            <Row justifyContent="space-between" px="s16" height={48} alignItems="center">
                <Text variant="headlineMedium">Results</Text>
                <CashBalanceButton />
            </Row>
            <Box px="s16" flex={1}>
                <GameResultsSectionList />
            </Box>
        </Screen>
    );
};
